// src/components/gavion/meetings/MeetingNoteTimelineBody.tsx
import { useGetOne, type Identifier } from "ra-core";
import { Skeleton } from "@/components/ui/skeleton";
import { MeetingNoteCard } from "./MeetingNoteCard";
import type { MeetingNoteRow } from "./types";

export const MeetingNoteTimelineBody = ({
  noteId,
  variant = "meeting",
}: {
  noteId: Identifier;
  /** GAVION granola-calls: "call" under a call entry. */
  variant?: "meeting" | "call";
}) => {
  const { data, isPending } = useGetOne<MeetingNoteRow>("meeting_notes", {
    id: noteId,
  });
  if (isPending) return <Skeleton className="h-16" />;
  return data ? <MeetingNoteCard note={data} variant={variant} /> : null;
};
